<div class="navbar-nav">
  <ng-container *ngFor="let item of menu$ | async">
    <a
      *ngIf="item.route"
      class="nav-item nav-link"
      [routerLink]="item.route"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }">
      {{ item.label }}
    </a>

    <!-- Dropdown parent -->
    <div *ngIf="item.children" class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle pointer-link"
        role="button"
        data-bs-toggle="dropdown">
        {{ item.label }}
      </a>

      <ul class="dropdown-menu">
        <li *ngFor="let child of item.children">
          <a
            class="dropdown-item"
            [routerLink]="child.route">
            {{ child.label }}
          </a>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
